// extracted by mini-css-extract-plugin
export var alertIcon = "_uj-0";